import { render, staticRenderFns } from "./learn_chinese_language.vue?vue&type=template&id=196a2ba6&scoped=true"
import script from "./learn_chinese_language.vue?vue&type=script&lang=js"
export * from "./learn_chinese_language.vue?vue&type=script&lang=js"
import style0 from "./learn_chinese_language.vue?vue&type=style&index=0&id=196a2ba6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196a2ba6",
  null
  
)

export default component.exports